import { word_limit } from "./inc/word-limiting";

import 'jquery-form';
import 'select2';

import './utils/jquery.live-shim';

import tabbedSelect from './components/tabbedSelect';

import { appendFormError } from './inc/formUtils';

import improvedSelect from './components/improved-select';
import './modules/cf7';

const jQuery = $;

/* main script global vars */
window.mapMarkersColors = ['#80926d', '#b38200', "#FD8E6A"];
window.mapPointsFeatures = [];
window.clusterRadius = 44;
window.bounds = [
    [-16.339526, 46.172467], /* Southwest coordinates */
    [25.862665, 66.654925]  /* Northeast coordinates */
];

/* init pages events */
$(document).ready(function () {

    // $('.js-improved-select').select2();
    $('.js-improved-select').each((i, sel) => {
        improvedSelect($(sel))
    });

    /* init select2 */
    if ($(".js-example-basic-single").length) {
        $('.js-example-basic-single').each(function () {
            $(this).select2();
        });
    }

    /* member buddypress admins */
    $("#group_members-order-by").change(function (e) {
        var select = $("#group_members-order-by").val();
        if (select == "group_activity") {
            $('#member-list li.hide').hide();
            e.preventDefault();
            location.reload();
        }
    });

    if (($("#group_members-order-by").val()) == "group_activity") {
        $('#member-list li.hide').hide();
    }
    /* end init select2 */

    /* make first media tab active on post page */
    var tabsWrap = $("#tabsWrap");
    if (tabsWrap.find(".article-content-wrap__item").length) {
        var firstMediaTab = tabsWrap.find(".article-content-wrap__item:first");
        firstMediaTab.addClass("active");
        var picker = firstMediaTab.data("attr");
        $(".tab-item[data-attr='" + picker + "']").addClass("active");
    }
    /* end make first media tab active on post page */

    /* advanced search */
    if ($("#btnAdvancedSearch").length) {
        var btnAdvancedSearch = $("#btnAdvancedSearch");
        var btnClearFilter = $("#btnClearFilter");
        btnAdvancedSearch.on("click", function () {
            if ($("input[id='s'][name='s']").val() !== '') {
                $("#as_input_title_keyword").val($("input[id='s'][name='s']").val());
            }
        });
        btnClearFilter.on("click", function () {
            document.location = '/all-articles';
        });
    }
    /* end advanced search */

    /* post comment form */
    if ($("#commentform").length) {
        var commentForm = $("#commentform");
        var commentTextField = $("#comment");

        commentTextField.on("keyup", function () {
            if (commentTextField.hasClass("input-error") && commentTextField.val() !== '') {
                commentTextField.removeClass("input-error");
                if (commentForm.find(".input-error-text").length) {
                    commentForm.find(".input-error-text").stop(true, true).slideUp(500, function () {
                        commentForm.find(".input-error-text").remove();
                    });
                }
            }
        });

        commentForm.on("submit", function (e) {
            if (!commentTextField.val() || commentTextField.val() === '') {
                e.preventDefault();
                commentTextField.addClass("input-error");
                var errorMessage = $('<div class="input-error-text">Please enter comment text</div>');
                commentForm.append(errorMessage);
                errorMessage.stop(true, true).slideDown(500);
            } else {
                if (commentForm.find(".input-error-text").length) {
                    commentForm.find(".input-error-text").remove();
                    commentTextField.removeClass("input-error");
                }
            }
        });
    }
    /* end post comment form */



    /* tip off form */
    if ($("#tipOffForm").length) {

        var tipOffForm = $("#tipOffForm");
        var tipOffFormTabsSwitcher = tipOffForm.find("select[name='tipping']");
        var firstTab = $(".tip-off-person-form__tab:first");
        var tipOffUserEmail = $("#tipOffUserEmail");

        tipOffForm.find(".wpcf7-validates-as-email").on("input keyup", function () {
            //tipOffUserEmail.text($(this).val());
        });
        tipOffForm.find("input[name='webaddress']").on("change", function () {
            if (($(this).val().indexOf("http://") != 0)) {
                var value = "http://" + $(this).val();
                $(this).val(value);
            }
        });
        firstTab.show();
        firstTab.find("label").each(function () {
            var label = $(this);
            var elemControl = label.closest(".cf7-item").find(".wpcf7-form-control");
            if (label.text().indexOf('*') !== -1) {
                elemControl.addClass("wpcf7-validates-as-required").removeClass("error");
                if (elemControl.closest(".cf7-item").find("span.error")) {
                    elemControl.closest(".cf7-item").find("span.error").remove();
                }
            }
        });

        tipOffFormTabsSwitcher.on("change", function () {

            var tabToShow = $(".tip-off-person-form__tab[data-tab='" + $(this).val().toLowerCase().split(" ").join("-") + "']");

            var selected = tipOffForm.find('.wpcf7-form-control.wpcf7-select').val();
            if (selected == "A person with information") {
                $(".tip-off-person-form__tab[data-tab='a-piece-of-content'] input, .tip-off-person-form__tab[data-tab='a-piece-of-content'] textarea").val("");
                $(".tip-off-person-form__tab[data-tab='a-place'] input,.tip-off-person-form__tab[data-tab='a-place'] textarea").val("");
            } else if (selected == "A piece of content") {
                $(".tip-off-person-form__tab[data-tab='a-person-with-information'] input,.tip-off-person-form__tab[data-tab='a-person-with-information'] textarea").val("");
                $(".tip-off-person-form__tab[data-tab='a-place'] input, .tip-off-person-form__tab[data-tab='a-place'] textarea").val("");
            } else if (selected == "A place") {
                $(".tip-off-person-form__tab[data-tab='a-person-with-information'] input,.tip-off-person-form__tab[data-tab='a-person-with-information'] textarea").val("");
                $(".tip-off-person-form__tab[data-tab='a-piece-of-content'] input,.tip-off-person-form__tab[data-tab='a-piece-of-content'] textarea").val("");
            }

            $(".tip-off-person-form__tab").stop(true, true).fadeOut(300).filter(tabToShow).show();

            $(".tip-off-person-form__tab").each(function () {
                var tab = $(this);
                tab.find("label").each(function () {
                    var label = $(this);
                    var elemControl = label.closest(".cf7-item").find(".wpcf7-form-control");
                    if (label.text().indexOf('*') !== -1) {
                        (tab.is(tabToShow)) ?
                            elemControl.addClass("wpcf7-validates-as-required") :
                            elemControl.removeClass("wpcf7-validates-as-required");
                        elemControl.removeClass("error");
                        if (elemControl.closest(".cf7-item").find("span.error")) {
                            elemControl.closest(".cf7-item").find("span.error").remove();
                        }
                    }
                });
            });
        });
    }
    /* end tip off form */

    /* login form */
    if ($("#loginForm").length) {

        var loginForm = $("#loginForm");

        if (loginForm.find("input#user_pass").hasClass("error")) {
            loginForm.find("input#user_pass").after($("<span class='error'>Please enter your password</span>"));
        }
    }
    /* end login form */

    /* restore password */
    if ($("#forgotPasswordForm").length) {

        var forgotPasswordForm = $("#forgotPasswordForm");
        var userLoginField = $("#user_login");
        var labelWrap = forgotPasswordForm.find(".tip-off-person-form__item-wrap");
        var restorePasswordPopup = $("#restorePasswordPopup");

        userLoginField.on("keyup input", function () {
            if (userLoginField.val() !== '' && userLoginField.hasClass("error")) {
                userLoginField.removeClass("error");
                if (labelWrap.find(".error").length) {
                    var errorMessage = labelWrap.find(".error");
                    errorMessage.stop(true, true).slideUp(500, function () {
                        errorMessage.remove();
                    });
                }
            }
        });

        restorePasswordPopup.find(".popup-close").on("click", function () {
            restorePasswordPopup.stop(true, true).fadeOut(500);
        });

        forgotPasswordForm.find(".btn").on("click", function (e) {
            e.preventDefault();
            if (userLoginField.val() === '') {
                userLoginField.addClass("error");
                appendFormError(labelWrap, false, 'Please enter your login or email')
            } else if (userLoginField.val() !== '') {
                $.post(forgotPasswordForm.data("action"), {user_login: userLoginField.val()}, function (response) {
                    response = JSON.parse(response);
                    if (response.error && response.error.length && !labelWrap.find(".error").length) {
                        userLoginField.addClass("error");
                        appendFormError(labelWrap, false, response.error);
                    } else if (response.success && response.success.length) {
                        userLoginField.removeClass("error");
                        restorePasswordPopup.stop(true, true).fadeIn(500);
                    }
                })
            }
        });
    }
    /* end restore password */

    /* load national and unverified location posts maps pins */
    // loadPostsToMapPin("#unverifiedLocationPostsPin");
    // loadPostsToMapPin("#nationalArticlesPostsPin");
    /* wnd load national and unverified location posts maps pins */

    tabbedSelect('#source-of-content-search', '#source-of-content-search-tabs');


    /* host a group form */
    hostGroupForm();
    /* end host a group form */

    /* initiates group form */
    initiatesGroupForm();
    /* end initiates group form */

    /* add event form */
    addEventForm();
    /* end add event form */
    // zoomCanvas();
});


function hostGroupForm() {

    $('input[id=file-avatar]').change(function (e) {
        var fileName = $('input[id=file-avatar]')[0].files[0].name;
        $('.logo').val(fileName);
    });

    $('input[id=file-cover]').change(function (e) {
        var fileName = $('input[id=file-cover]')[0].files[0].name;
        $('.cover').val(fileName);
    });

    $('#host-a-group-form').ajaxForm({
        success: function (object) {
            if (object.status === 'success') {
                $(".cf7-popup").fadeIn(500);
                $('#host-a-group-form').resetForm();
                $('#tagBox .tag').removeClass('tag').hide();
            } else if (object.status === 'image') {
                console.log(object.field);
                var element = $('#span-' + object.field);
                element.addClass('error').removeClass('hidden');
                element.text(object.message);
                $('input[id=' + object.field + ']').on('change keyup', function () {
                    element.addClass('hidden').removeClass('error').text('');
                });
            } else {
                $.each(object, function (key, data) {
                    $.each(data, function (index, data) {
                        $('#span-' + data.class).removeClass('hidden').addClass('error');
                        if (data.class === 'terms_agree') {
                            var element = $('#check');
                            element.on('change keyup', function () {
                                $('#span-' + data.class).addClass('hidden').removeClass('error');
                            });
                        } else if (data.class === 'option') {
                            var element_1 = $('#initiated-1');
                            element_1.on('change keyup', function () {
                                $('#span-option').addClass('hidden').removeClass('error');
                            });
                            var element_2 = $('#initiated-2');
                            element_2.on('change keyup', function () {
                                $('#span-option').addClass('hidden').removeClass('error');
                            });
                        } else {
                            var element = $('#' + data.class);
                            element.addClass('error').focus();
                            element.on('change keyup', function () {
                                $('#span-' + data.class).addClass('hidden').removeClass('error');
                                $('#' + data.class).removeClass('error');
                            });
                        }
                    })
                });
            }
        },
        dataType: "json"
    });

    $(".popup-close").on("click", function () {
        $(".cf7-popup").fadeOut(500);
    });
}

function removeImage(elementId, elementClass) {
    $('.' + elementClass).val('');
    $('#' + elementId).val('');
}

function initiatesGroupForm() {
    $('#initiates-form').ajaxForm({
        success: function (object) {
            if (object.status === 'error') {
                $.each(object, function (key, data) {
                    if (data === 'error') {
                        return true;
                    }
                    $('.span-' + data.class).removeClass('hidden').addClass('error');
                    var element = $('[name=' + data.class + ']');
                    element.addClass('error');
                    element.on('change keyup', function () {
                        $('.span-' + data.class).removeClass('error').addClass('hidden');
                        element.removeClass('error');
                    });
                });
            } else {
                $(".initiates-popup-wrap").show();
                $('#initiates-form').resetForm();
            }
        },
        dataType: "json"
    });

    $(".popup-close").on("click", function () {
        $(".initiates-popup-wrap").fadeOut(500);
    });
}

function addEventAjax() {

    $('#add-event-form').ajaxForm({
        success: function (object) {
            if (object.status) {
                $(".add-event-warp").show();
                $('#add-event-form').resetForm();
            } else {
                $.each(object, function (key, data) {
                    if (!data) {
                        return true;
                    }
                    $.each(data, function (index, field) {

                        if (field === 'date') {
                            $('span[name=span-' + field + ']').removeClass('hidden').addClass('error');
                            $('input[name^=date').each(function () {
                                $(this).addClass('error');
                                $(this).on('change keyup', function () {
                                    $('span[name=span-' + field + ']').removeClass('error').addClass('hidden');
                                    $(this).removeClass('error');
                                });
                            });
                        } else {
                            $('span[name=span-' + field + ']').removeClass('hidden').addClass('error');
                            var element = $('[name=' + field + ']');
                            element.addClass('error');
                            element.on('change keyup', function () {
                                $('span[name=span-' + field + ']').removeClass('error').addClass('hidden');
                                element.removeClass('error');
                            });
                        }
                    });
                });
            }
        },
        dataType: "json"
    });
}

function addEventForm() {

    addEventAjax();

    $(".popup-close").on("click", function () {
        $(".add-event-warp").fadeOut(500);
    });
}


/* additional functionality*/
$(document).ready(function () {

    // setTimeout(function () {
    //     $('#canvas-wrapper canvas').wrap('<div class="frame"></div>');
    // }, 3000);

    // $('#canvas-wrapper').after('</div>');

    $(".contribute-form__input.date").blur(function () {
        var value = $(this).val();

        if (value == 0 && value != '') {
            $(this).val('01');
        }
        if (value < 10 && value > 0 && value != '') {
            var new_value = "0" + value;
            if ((value.length) < 2) {
                $(this).val(new_value);
            } else {
                $(this).val(value);
            }
        }
    });

    //hide buttons from profile page
    $('#member-events-personal-li #user-member-events, #profile-personal-li #profile').hide();

    //hide cover image warning message
    $('.bp-cover-image-status p.warning').hide();

    //hide compose button
    $('#compose-personal-li #compose').hide();

    $('#describe_group,#interest_in_hosting,#description').keydown(function () {
        word_limit($(this), 100);
    });
    $('#additionalAboutInformation').keydown(function () {
        word_limit($(this), 1000);
    });


    //RESET PASSWORD FORM
    function resetForm() {

        $('#resetForm span.error').hide();
        $('#resetForm').submit(function (e) {

            e.preventDefault();
            var psw1 = $('#resetForm input#psw1').val();
            var psw2 = $('#resetForm input#psw2').val();
            var id_user = $('#resetForm input#id_user').val();
            var action = $('#resetForm input#action').val();

            var info = {
                action: action,
                id_user: id_user,
                psw: psw1
            };

            if (psw1 != psw2) {
                $('#resetForm span.error').show();
                $('#resetForm input').addClass('error').addClass('invalid');
                return false;
            } else {
                $.post({
                    url: alexandrian_wicca.ajaxurl,
                    data: info,
                    success: function (data) {
                        console.log(data);
                        $('.contacts-popup-wrap.reset-popup').show();
                    },
                    error: function (data) {
                        console.log(data);
                    },

                });
            }

        });
    }

    resetForm();

    //Comments on ajax
    function commentForm() {

        $('#coment_form').ajaxForm({
            success: function (data) {
                var author = $('#coment_form input#author').val();
                var pre = author.split(' ');
                var prefix = "";
                if (pre.length > 1) {
                    $.each(pre, function (index, value) {
                        prefix += value[0].toUpperCase();
                    });
                } else {
                    prefix = pre[0][0] + pre[0][1];
                }
                var comment = $('#coment_form input#comment').val();
                if (comment != '') {
                    var html = "<div style='position: relative; padding: 0 0 20px 48px;'><div style='position: absolute; left: 0; top: 0; border-radius: 50%; width: 38px; height: 38px; background: #a8a8a8; color: #fff; text-transform: uppercase; text-align: center; font-size: 20px; font-weight: bold; line-height: 38px;'>" + prefix + "</div><div style='font-weight: bold; font-size: 18px; line-height: 32px; color: #454545;'>" + author + "</div><div style='font-size: 18px; line-height: 24px; color: #4d4d4d; padding-top: 2px;'>" + comment + "</div></div>";
                    //$(".tab-content__content.comment-content").append(html);
                    alert('Your comment will appear after it is approved!');
                    $('#coment_form input#comment').val('');
                }
            },
            error: function (data) {
                console.log('error');
            },
            dataType: "json"
        })

    }

    commentForm();


    //leave and join groups ajax
    var url = $('#item-buttons #ajax_url').text();
    $('#item-buttons .join-group').attr('data-url', url);

    $('.no-button, .icon-popup_close_icon_grey').on('click', function () {
        $(this).parents('.contacts-popup-wrap').hide();
    });

    // leave group on single group
    function leave_single() {

        $('#item-buttons .leave-group').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            $('.leave-group-popup').fadeIn(100);
        });

        $('.activity  .yes-button').bind('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('data-url');
            var info = {
                action: 'leave_group_by_ajax',
            };
            $.post({
                url: url,
                data: info,
                success: function (data) {
                    $('.leave-group-popup').hide();
                    $('.group-button.public.generic-button').html("<a href='' class='group-button join-group' data-url='" + url + "'>Join Group</a>");
                    join_single();
                },
                error: function (data) {
                    console.log(data);
                },

            });
        });
    }

    // join group on single group
    function join_single() {

        $('#item-buttons .join-group').bind('click', function (e) {
            e.preventDefault();
            $('.welcome-to-group-popup').show(100);
            var url = $(this).attr('data-url');
            var info = {
                action: 'join_group_by_ajax',
            };
            $.post({
                url: url,
                data: info,
                success: function (data) {
                    $('.welcome-to-group-popup').show(100);
                    setTimeout(function () {
                        $('.welcome-to-group-popup').hide(100);
                    }, 5000);
                    $('.group-button.public.generic-button').html("<a href='' class='group-button leave-group'>Leave Group</a>");
                    leave_single();
                },
                error: function (data) {
                    console.log(data);
                },
            });

        });

    }

    leave_single();
    join_single();

    // leave group on members page
    function leave_members_page() {

        $('.action .leave-group').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            $('.leave-group-popup').fadeIn(100);

            var group = $(this).parent('.generic-button').attr('id');
            var groupId = group.split('-');
            groupId = groupId[1];

            $(this).attr('data-leave-id', groupId);
            $('.leave-group-popup .popup-group-id').html("<p id='group_id'>" + groupId + "</p>")

        });

        $('.popups .yes-button').bind('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('data-url');
            var id_group = $(this).parents('.popup').find('p#group_id').text();
            var info = {
                action: 'leave_group_by_ajax',
                type: 'members',
                id_group: id_group
            };
            $.post({
                url: url,
                data: info,
                success: function (data) {
                    $('.leave-group-popup').hide();
                    $(".group-button.public.generic-button a[data-leave-id=" + id_group + "]").parent().html("<a href='' class='group-button join-group' data-url='" + url + "'>Join Group</a>");
                    console.log('success', data);
                    join_members_page();
                },
                error: function (data) {
                    console.log('err', data);
                },

            });

        });

    }

    // join group on members page
    function join_members_page() {

        var ajaxurl = $('#groups-list p#ajax_url').text();
        $('.action .join-group').attr('data-url', ajaxurl);

        $('.action .join-group').bind('click', function (e) {

            e.preventDefault();
            $('.welcome-to-group-popup').show(100);

            var url = $(this).attr('data-url');
            var parent = $(this).parent('.generic-button');
            var group = $(this).parent('.generic-button').attr('id');
            var groupId = group.split('-');
            groupId = groupId[1];

            var info = {
                action: 'join_group_by_ajax',
                type: 'members',
                id_group: groupId
            };

            $.post({
                url: url,
                data: info,
                success: function (data) {
                    $('.welcome-to-group-popup').show(100);
                    $(parent).html("<a href='' class='group-button leave-group'>Leave Group</a>");
                    setTimeout(function () {
                        $('.welcome-to-group-popup').hide(100);
                    }, 5000);
                    leave_members_page();
                    console.log(data);
                },
                error: function (data) {
                    console.log(data);
                },
            });

        });

    }

    leave_members_page();
    join_members_page();

    // delete events
    $(document).on('click', '#events-delete-button', function () {

        var eventId = $(this).attr('data-id');
        var parent = $(this).parents('.events-info');

        var info = {
            action: 'delete_event_by_ajax',
            id: eventId
        };

        $.post({
            url: alexandrian_wicca.ajaxurl,
            data: info,
            success: function (data) {
                parent.fadeOut(100);
                console.log(data);
            },
            error: function (data) {
                console.log(data);
            },
        });

    });

    // deactivate user
    $('li#change-cover-image-personal-li').parent('ul').append("<li id='deactive_own_profile'><a id='deactive_profile_a' href>Deactivate account</a></li>");

    $('#deactive_profile_a').on('click', function (e) {
        e.preventDefault();
        if (confirm('Are you sure? Your profile will be deactivated! All your contributions will still be on the website.')) {

            var info = {
                action: 'deactivate_own_profile'
            };
            $.post({
                url: alexandrian_wicca.ajaxurl,
                data: info,
                success: function (data) {
                    window.location.replace('/log-in/');
                    console.log(data);
                },
                error: function (data) {
                    console.log(data);
                },
            });
        }
    })

    // add_event-date_validation
    function min_at_add_event() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        $("#add-event-form input.year.all_data").attr('min', yyyy);

        $("#add-event-form input.all_data").live('change', function () {

            var day = $("#add-event-form input.day.all_data").val();
            var month = $("#add-event-form input.month.all_data").val();
            var year = $("#add-event-form input.year.all_data").val();

            if (year == yyyy) {
                $("#add-event-form input.month.all_data").attr('min', mm);
                $("#add-event-form input.day.all_data").attr('min', dd);
            } else if (year > yyyy) {
                $("#add-event-form input.month.all_data").attr('min', 1);
                $("#add-event-form input.day.all_data").attr('min', 1);
            }

            if ((year >= $("#add-event-form input.year.all_data").attr('min'))
                && (month >= $("#add-event-form input.month.all_data").attr('min'))
                && (day >= $("#add-event-form input.day.all_data").attr('min'))
            ) {
                $("#add-event-form span.hidden.error").hide();
            } else {
                $("#add-event-form span.hidden.error").show();
            }
        });
    }

    min_at_add_event();

    //hide settings menu
    $("#group-settings, .action .member-promote-to-mod,form#group-settings-form .group-mods-list").hide();

    function forPagination() {
        var counterPage = parseInt($('.navigate .js-page.checked').text());
        var currentPage = $('.navigate .js-page.checked');
        var page = $('.navigate .js-page');
        var lastPage = page.last();
        var lastPageCount = parseInt(page.last().text());
        var firstPage = page.first();
        page.hide();
        currentPage.show();

        if (counterPage) {
            var prevCurentElement = currentPage.prev();
            prevCurentElement.show();
            prevCurentElement.prev().show();
            prevCurentElement.prev().prev().show();
            prevCurentElement.prev().prev().prev().show();

            var nextCurentElement = currentPage.next();
            nextCurentElement.show();
            nextCurentElement.next().show();
            nextCurentElement.next().next().show();
            nextCurentElement.next().next().next().show();

        }
        firstPage.show();

        if (firstPage.hasClass('checked') || firstPage.next().hasClass('checked') || firstPage.next().next().hasClass('checked') || firstPage.next().next().next().hasClass('checked') || firstPage.next().next().next().next().hasClass('checked')) {

        } else if ((counterPage - 1) > 5) {
            firstPage.after('...');
            firstPage.next().hide();
        }

        lastPage.show();
        if (lastPage.hasClass('checked')) {

        } else if ((lastPageCount - counterPage) > 5) {
            lastPage.before('...');
        }

        if (lastPage.hasClass('checked')) {
            $('i.icon-small_special_arrow_right_grey').hide();
        }
        if (firstPage.hasClass('checked')) {
            $('i.icon-small_special_arrow_left_grey').hide();
        }

    }

    forPagination();


    function showMap() {

        $('.hiddenMap').css('opacity', '0');
        $('.hiddenMap.national-pin-wrap').css('opacity', '0');
        $('.hiddenMap.unverified-pin-wrap').css('opacity', '0');


        $('#scrollToFrontPageContent').live('click', function () {

            if ($('#newMap').hasClass('hiddenMap')) {
                $('#newMap').removeClass('hiddenMap').addClass('showMap').css('opacity', '1');
                $('.hiddenMap.national-pin-wrap').removeClass('hiddenMap').addClass('showMap').css('opacity', '1');
                $('.hiddenMap.unverified-pin-wrap').removeClass('hiddenMap').addClass('showMap').css('opacity', '1');
            }

        });

    }

    showMap();

    var count_members = $('.count_member_without_deactivated').text();
    $('li#members-groups-li span').text(count_members);
    $('#invites-personal-li').hide();
    $('ul.padding0')
        .css({
            'padding-top': '0px',
            'padding-bottom': '0px'
        });

    // $('li.groups .button.item-button.delete-activity.confirm').hide();
});


$('a[href^="#"]').each((i, el) => {
    const anchor = $(el).attr('href');
    const target = $(anchor);

    if (target.length) {
        target.prepend(`<a id="${ target.attr('id') }" class="anchor-target"><span></span></a>`);
        target.removeAttr('id');
    }
});